unit db.connection;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, XData.Web.Connection,
  XData.Web.Request,
  XData.Web.Response,
  WEBLib.WebCtrls, WEBLib.Toast,
  WEBLib.Storage, XData.Web.Client, WEBLib.LocalFiles,
  Vcl.Forms, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset;

type
  TAppConfig = class
  private
    FApiUrl: string;
    FRepUrl: string;
  public
    constructor Create;
    property ApiUrl: string read FApiUrl write FApiUrl;
    property RepUrl: string read FRepUrl write FRepUrl;
  end;

  TdmData = class(TDataModule)
    dbConnect: TXDataWebConnection;
    procedure WebDataModuleCreate(Sender: TObject);
    procedure dbConnectRequest(Args: TXDataWebConnectionRequest);
    procedure dbConnectError(Error: TXDataWebConnectionError);
    procedure dbConnectResponse(Args: TXDataWebConnectionResponse);
    procedure WebDataModuleDestroy(Sender: TObject);
  private
    { Private declarations }
    iErrorCount : Integer;
    procedure LoadProc(Config : TAppConfig);
  public
    { Public declarations }
    sToken : String;
    LStorage : TLocalStorage;
    gApiUrl,
    gRepUrl : String;
  protected procedure LoadDFMValues; override; end;

const
    TokenName = 'SSAP_TOKEN';
    UserName = 'SSAP_USER';
    UserNo = 'SSAP_USERNO';
    ExpiryDate = 'SSAP_EXP';
    ErrorCount = 'SSAP_ERROR';

var
  dmData: TdmData;

implementation



{ TAppConfig }

constructor TAppConfig.Create;
begin
  FApiUrl := '';
  FRepUrl := '';
end;

{%CLASSGROUP 'Vcl.Controls.TControl'}

{$R *.dfm}

procedure TdmData.dbConnectError(Error: TXDataWebConnectionError);
begin
   Inc(iErrorCount);
  LStorage.setvalue(ErrorCount, IntToStr(iErrorCount));
  if (not dbConnect.Connected) and (iErrorCount < 3) then
    dmData.OnCreate(nil)
  else
    begin
      iErrorCount := 0;
      LStorage.setvalue(ErrorCount, IntToStr(iErrorCount));

    end;
end;

procedure TdmData.dbConnectRequest(Args: TXDataWebConnectionRequest);
begin
  if sToken <> '' then
    Args.Request.Headers.SetValue('Authorization', 'Bearer ' + sToken);
end;

procedure TdmData.dbConnectResponse(Args: TXDataWebConnectionResponse);
begin
  if Args.Response.StatusCode <> 200 then
    begin

    end;
end;

procedure TdmData.LoadProc(Config : TAppConfig);
begin
  dbConnect.Connected := False;
  dbConnect.URL := Config.ApiUrl;
  dbConnect.open;

end;

procedure TdmData.WebDataModuleCreate(Sender: TObject);
  var
    Conn : TXDataWebConnection;
  Procedure OnSuccess(Response: IHttpResponse);
    Var
      Obj: TJSObject;
      Config: TAppConfig;
      lResponse: String;
  Begin
    Config := TAppConfig.Create;
    Try
      If Response.StatusCode = 200 Then
      Begin
        lResponse := Response.ContentAsText;
        Obj := TJSObject(TJSJSON.parse(lResponse));

        If JS.toString(Obj['ApiUrl']) <> '' Then
          Config.ApiUrl := JS.toString(Obj['ApiUrl']);

        If JS.toString(Obj['RepUrl']) <> '' Then
          Config.RepUrl := JS.toString(Obj['RepUrl']);
      End;
    Finally
      LoadProc(Config);
      gApiUrl := Config.ApiUrl;
      gRepUrl := Config.RepUrl;
      Config.Free;
    End;
  End;

  procedure OnError;
  var
    Config: TAppConfig;
  begin
    Config := TAppConfig.Create;
    try
      LoadProc(Config);
    finally
      Config.Free;
    end;
  end;

begin
  if not Assigned(LStorage) then
    LStorage := TLocalStorage.Create;
  if Trim(LStorage.GetValue(ErrorCount)) = '' then
    iErrorCount := 0
  else
    iErrorCount := StrToInt(LStorage.GetValue(ErrorCount));
  sToken := '';
  if not Assigned(Conn) then
    Conn := TXDataWebConnection.Create(Nil);
  Try
    Conn.SendRequest(THttpRequest.Create('config/config.json'), @OnSuccess, @OnError);
  Finally
    Conn.Free;
  End;
end;

procedure TdmData.WebDataModuleDestroy(Sender: TObject);
begin
  LStorage.Free;

end;

procedure TdmData.LoadDFMValues;
begin
  inherited LoadDFMValues;

  dbConnect := TXDataWebConnection.Create(Self);

  dbConnect.BeforeLoadDFMValues;
  try
    Name := 'dmData';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    SetEvent(Self, 'OnDestroy', 'WebDataModuleDestroy');
    Height := 321;
    Width := 371;
    dbConnect.SetParentComponent(Self);
    dbConnect.Name := 'dbConnect';
    dbConnect.URL := 'http://192.168.255.2:20080/summatechdb/testdata_db';
    SetEvent(dbConnect, Self, 'OnError', 'dbConnectError');
    SetEvent(dbConnect, Self, 'OnRequest', 'dbConnectRequest');
    SetEvent(dbConnect, Self, 'OnResponse', 'dbConnectResponse');
    dbConnect.Left := 96;
    dbConnect.Top := 48;
  finally
    dbConnect.AfterLoadDFMValues;
  end;
end;

end.
